interface IAgencyExecutionConfig {
    type: string
}
export interface IWebIQSettings {
    bucket: string;
    csvName: string;
}
interface ICSVExecutionConfig {
    fileInfo: IWebIQSettings
}
export type ExecutionConfig = Partial<IAgencyExecutionConfig> & Partial<ICSVExecutionConfig>
export interface IETLLog extends ExecutionConfig {
    id: string,
    startDate: number,
    endDate: number,
    numberOfCases: number
}
export interface IRekLog {
    bucket: string,
    key: string,
    date: number,
}
export type sortType = Array<{ [key: string]: 'asc' | 'desc' }>;
export interface IServiceStatusRequest {
    sort: sortType;
    page: number;
    size: number;
}
export interface IServiceStatusResponse {
    total: number,
    results: Array<IETLLog | IRekLog>
}

export const initialETLLogs: IServiceStatusRequest = {
    sort: [{ startDate: 'desc' }],
    page: 0,
    size: 10
};

export const initialRekognitionLogs: IServiceStatusRequest = {
    sort: [{ date: 'desc' }],
    page: 0,
    size: 10
};